// extracted by mini-css-extract-plugin
export default {"flavor_option":"WH","out_of_stock_text":"XH","out_of_stock":"YH","flavor_option_image":"ZH","flavor_option_info":"aI","flavor_option_title":"bI","flavor_option_limited":"cI","flavor_option_amount_wrapper":"eI","flavor_option_amount_button":"fI","zero_amount":"gI","no_flavors":"hI","no_flavors_active":"iI","flavor_option_select_wrapper":"jI","flavor_option_select_wrapper__selected":"kI"};
    if(module.hot) {
      // 1713211521346
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  